import React, { useState } from "react";
import PropTypes from "prop-types";
import { RichText } from "prismic-reactjs";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/core/styles";
import style from "./style";
import CustomLink from "../CustomLink";
import VideoModal from "../VideoModal";
import {
  structuredTextPropTypes,
  imagePropTypes,
} from "../../utils/prop-types";

const HeroBackgroundImage = ({ primary, classes }) => {
  const [openModal, setOpenModal] = useState(false);

  const openVideoDialog = () => {
    setOpenModal(true);
  };

  const closeVideoDialog = () => {
    setOpenModal(false);
  };
  const styles = {};
  if (primary.data && primary.data.featured_image) {
    styles.backgroundImage = `url(${primary.data.featured_image.url})`;
  }

  return (
    <div className={classes.workDetailsHeroBackground} style={styles}>
      <div className={classes.backgroundOverlay}>
        <Container maxWidth="lg" className="container">
          <Grid
            container
            direction="column"
            justify="center"
            alignItems="center"
            className="container"
          >
            {primary.data.title && (
              <Typography variant="h3" component="h1" className="description">
                {RichText.asText(primary.data.title)}
              </Typography>
            )}
            {primary.data.project_category.data &&
              primary.data.project_category.data.title && (
                <CustomLink link={primary.data.project_category}>
                  <Typography
                    variant="subtitel1"
                    className="projectCatTitle boldText"
                  >
                    {RichText.asText(primary.data.project_category.data.title)}
                  </Typography>
                </CustomLink>
              )}
            <div className={classes.heroButton}>
              <CustomLink link={primary.data.cta1_button_link}>
                <Button variant="contained" color="primary">
                  {RichText.asText(primary.data.cta1_button_text)}
                </Button>
              </CustomLink>
              {primary.data.secondary_button_type ? (
                <Button onClick={openVideoDialog} variant="outlined">
                  {RichText.asText(primary.data.cta2_button_text)}
                </Button>
              ) : (
                <CustomLink link={primary.data.cta2_button_link}>
                  <Button variant="outlined">
                    {RichText.asText(primary.data.cta2_button_text)}
                  </Button>
                </CustomLink>
              )}
            </div>
          </Grid>
        </Container>
        <VideoModal
          open={openModal}
          handleClose={closeVideoDialog}
          video={primary.data.vimeo_link}
        />
      </div>
    </div>
  );
};

HeroBackgroundImage.propTypes = {
  slice: PropTypes.shape({
    primary: PropTypes.shape({
      title: structuredTextPropTypes,
      description: structuredTextPropTypes,
      backgroundImage: imagePropTypes,
      primaryCtaButtonText: structuredTextPropTypes,
      secondaryCtaButtonText: structuredTextPropTypes,
    }).isRequired,
    items: PropTypes.array.isRequired,
  }).isRequired,
  classes: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default withStyles(style)(HeroBackgroundImage);
